export default __webpack_public_path__ + "static/media/11c.4ceabd4d.png";